import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const unreachable = (message: string): never => {
  throw new Error(`Unreachable: ${message}`);
};